class ProductDetailPrices extends Component {
	constructor(el) {
		super(el);
		this.priceOriginEl = this.$find('[data-price-original]');
		this.priceVatEl = this.$find('[data-price-vat]');
		this.priceNoVatEl = this.$find('[data-price-no-vat]');
		this.priceVatMocEl = this.$find('[data-price-vat-moc]');
		this.addEventListeners();
	}

	updatePrices(variant) {
		this.priceOriginEl.innerHTML = variant.originalPrice;
		this.priceVatEl.innerHTML = variant.priceVAT;
		this.priceNoVatEl.innerHTML = variant.price + ' ';
		if (this.priceVatMocEl) {
			this.priceVatMocEl.innerHTML = variant.priceVatMoc;
		}
	}

	addEventListeners() {
		EventBus.getInstance().addEventListener('productVariantChanged', e => this.updatePrices(e.detail));
	}
}
